// extracted by mini-css-extract-plugin
export default {"root":"_3V72E","llama":"_3Nk94","big":"_31xKy","small":"_1PLxa"};